import React from "react";
import {
  Card,
  Row,
  Col,
  Typography,
  Divider,
  Tag,
  Progress,
  Button,
  Modal,
} from "antd";
import { useNavigate } from "react-router-dom";
import {
  cancelSubscriptionApi,
  toggleSubscriptionApi,
} from "../../services/payment.service";
import { useAppDispatch } from "../../hooks/reduxHooks";
import Icon, { WarningOutlined } from "@ant-design/icons";
const { Title, Text, Link } = Typography;

interface SubscriptionCardProps {
  data: any;
  subscription_status?: any;
}

const SubscriptionCard: React.FC<SubscriptionCardProps> = ({
  data,
  subscription_status,
}) => {
  const {
    plan,
    status,
    price,
    remaining_days: daysLeft,
    total_days: totalDays,
    current_period_end: endDate,
  } = data || {};
  const navigate = useNavigate();
  const percent = Math.round((daysLeft / totalDays) * 100);
  const [loading, setLoading] = React.useState(false);
  const [subscriptionStatus, setSubscriptionStatus] = React.useState(
    subscription_status?.ends_at === null ? "active" : "canceled"
  );
  const [stripeStatus, setStripeStatus] = React.useState(
    subscription_status?.stripe_status || "Active"
  );
  const dispatch = useAppDispatch();
  const cancel = () => {
    setLoading(true);
    dispatch(
      toggleSubscriptionApi({
        finalCallback: () => {
          // Optional: Add any final callback logic here
          setLoading(false);
        },
        successCallback: (data: any) => {
          console.log("toggle data", data);
          setStripeStatus(data?.stripe_status);
          setSubscriptionStatus(data?.ends_at === null ? "active" : "canceled");
          // Optional: Add any success callback logic here
        },
      })
    );
  };
  return (
    <Card className="suscription-card spacing">
      <Row justify="space-between" align="middle">
        <Col>
          <div className="suscription-progress__heading">
            <Tag
              style={{ textTransform: "uppercase" }}
              color={stripeStatus === "Active" ? "green" : "red"}
            >
              {stripeStatus}
            </Tag>
            <h3 className="title">{plan}</h3>
          </div>

          <div className="suscription-progress-bar">
            <Progress
              type="circle"
              percent={percent}
              format={() =>
                stripeStatus === "Ended" || daysLeft === 0 ? (
                  <WarningOutlined
                    style={{
                      color: daysLeft === 0 ? "#eed202" : "#ff4d4f",
                    }}
                  />
                ) : (
                  `${daysLeft}d`
                )
              }
              strokeColor={stripeStatus === "Active" ? "#b5cc4c" : "#ff4d4f"}
              width={80}
            />
            <div style={{ textAlign: "center", marginTop: 8 }}>
              {stripeStatus === "Ended" ? (
                <Text>Your subscription has ended</Text>
              ) : daysLeft === 0 ? (
                <Text>Expires today</Text>
              ) : (
                <Text>
                  {daysLeft} / {totalDays} days left
                </Text>
              )}
            </div>
          </div>
        </Col>
        <Col>
          <div className="suscription-progress__heading-right">
            <div className="title-wrapper">
              <span>Subscription end date:</span>{" "}
              <span className="end-date">{endDate}</span>
            </div>
            <br />
            <Title level={4} style={{ margin: 0 }}>
              {price}
            </Title>
            <div
              className="plan-cancel"
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              {stripeStatus === "Ended" ? (
                <Button
                  className={
                    subscriptionStatus === "active"
                      ? "btn-danger"
                      : "btn-primary"
                  }
                  type="default"
                  loading={loading}
                  onClick={() => {
                    navigate("/payment-info");
                  }}
                >
                  Resubscribe
                </Button>
              ) : (
                <Button
                  className={
                    subscriptionStatus === "active"
                      ? "btn-danger"
                      : "btn-primary"
                  }
                  type="default"
                  loading={loading}
                  onClick={() => {
                    Modal.confirm({
                      title:
                        subscriptionStatus === "canceled"
                          ? "Reactivate Plan"
                          : "Cancel Plan",
                      content:
                        subscriptionStatus === "canceled"
                          ? "Are you sure you want to reactivate your subscription plan?"
                          : "Are you sure you want to cancel your subscription plan? You will lose access to premium features at the end of your billing cycle.",
                      onOk: () => cancel(),
                      okText:
                        subscriptionStatus === "canceled"
                          ? "Yes, Reactivate it"
                          : "Yes, Cancel it",
                      cancelText: "No, Keep it",
                    });
                  }}
                >
                  {subscriptionStatus === "canceled"
                    ? "Reactivate Plan"
                    : "Cancel Plan"}
                </Button>
              )}
            </div>
          </div>
        </Col>
      </Row>

      <Divider />

      <Text>Questions? Check out </Text>
      <Link>Billing FAQ</Link>
    </Card>
  );
};

export default SubscriptionCard;
